export var ServiceAccountScope;
(function (ServiceAccountScope) {
    ServiceAccountScope["SCIM_MANAGE"] = "scim:manage";
    ServiceAccountScope["ORG_ADMIN"] = "org:admin";
})(ServiceAccountScope || (ServiceAccountScope = {}));
//# sourceMappingURL=types.js.map